import React = require("react");
import Dropdown from '../custom-components/icon-text-button/Dropdown';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import FeedbackFormDialog from './FeedbackFormDialog';
import l10n from "../util/l10n";

import SmileIcon from "material-ui/svg-icons/social/mood";
import SadIcon from "material-ui/svg-icons/social/mood-bad";

export enum FeedbackType {
    POSITIVE,
    NEGATIVE
}

interface FeedbackButtonProps extends React.Props<FeedbackButton> {
    feedbackFeatureName: string;
    feedbackContext: string;
    useAlternativeColors?: boolean;
    style?: React.CSSProperties;
    anchorOrigin?: Object;
    targetOrigin?: Object;
    onFeedbackSubmit(
        feedbackContext: string,
        feedbackType: FeedbackType,
        feedbackText: string
    ): Promise<string>;
}

interface FeedbackButtonState {
    isExpanded: boolean;
    isFeedbackFormOpen: boolean;
    feedbackType: FeedbackType;
}

export default class FeedbackButton extends React.Component<FeedbackButtonProps, FeedbackButtonState> {

    static defaultProps = {
        anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
        targetOrigin: { vertical: 'top',    horizontal: 'right' }
    };

    constructor(props: FeedbackButtonProps) {
         super(props);
         this.state = {
             isExpanded: false,
             isFeedbackFormOpen: false,
             feedbackType: null
         };
     }

    getStyles() {
        return {
            root: Object.assign({}, {
                display: 'inline-block'
            }, this.props.style),
            dropdown: {
                display: 'block'
            },
            container: {
                padding: 0
            }
        };
    };

    render() {
        const styles = this.getStyles();

        const btnDropdownText = l10n("feedback.dropdown.button");
        const menuGoodFeedback = l10n("feedback.menu.positive");
        const menuBadFeedback = l10n("feedback.menu.negative");

        return (
            <div
                data-test-id="feedback-button"
                style={styles.root}
            >
                <Dropdown
                    isExpanded={this.state.isExpanded}
                    Icon={<SmileIcon />}
                    text={btnDropdownText}
                    onOpen={this.onOpen}
                    onClose={this.onClose}
                    style={styles.dropdown}
                    popoverChildrenStyle={styles.container}
                    useAlternativeColors={this.props.useAlternativeColors}
                    showArrow={false}
                    anchorOrigin={this.props.anchorOrigin}
                    targetOrigin={this.props.targetOrigin}
                    isSecondary={true}
                >
                    <Menu onChange={this.onFeedbackTypeSelect}>
                        <MenuItem
                            data-test-id="feedback-menu-positive"
                            key={1}
                            value={FeedbackType.POSITIVE + ''}
                            primaryText={menuGoodFeedback}
                            leftIcon={<SmileIcon />}
                        />
                        <MenuItem
                            data-test-id="feedback-menu-negative"
                            key={2}
                            value={FeedbackType.NEGATIVE + ''}
                            primaryText={menuBadFeedback}
                            leftIcon={<SadIcon />}
                        />
                    </Menu>
                </Dropdown>
                {
                    this.state.isFeedbackFormOpen
                      ? (
                            <FeedbackFormDialog
                                feedbackFeatureName={this.props.feedbackFeatureName}
                                feedbackType={this.state.feedbackType}
                                feedbackContext={this.props.feedbackContext}
                                onFeedbackSubmit={this.props.onFeedbackSubmit}
                                onDone={this.onDone}
                            />
                        )
                      : null
                }
            </div>
        );
    }

    private onDone = () => {
        this.setState({
            isExpanded: false,
            isFeedbackFormOpen: false,
            feedbackType: null
        });
    };

    private onOpen = () => {
        if (!this.state.isExpanded) {
            this.setState({
                isExpanded: true,
                isFeedbackFormOpen: false,
                feedbackType: null
            });
        }
    };

    private onClose = () => {
        if (this.state.isExpanded) {
            this.setState({
                isExpanded: false,
                isFeedbackFormOpen: false,
                feedbackType: null
            });
        }
    };

    private onFeedbackTypeSelect = (event: React.SyntheticEvent<{}>, value: string) => {
        this.setState({
            isExpanded: false,
            isFeedbackFormOpen: true,
            feedbackType: parseInt(value, 10)
        });
    };
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/feedback/FeedbackButton.tsx
 **/